import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import {
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Theme,
    Tooltip,
} from "@mui/material";
import { useAppSelector } from "@/Redux/Redux";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface EquipmentFilterTabProps {
    predefinedFilter: any;
    setTmpFilter: any;
    viewData?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    tabBar: {
        backgroundColor: "white",
    },

    checkboxAllLabel: {
        fontWeight: 700,
    },

    extrasIcon: {
        marginRight: 5,
        marginBottom: 8,
        display: "inline-flex",
        fontSize: 14,
    },
}));

const EquipmentFilterTab: FunctionComponent<EquipmentFilterTabProps> = ({
    predefinedFilter,
    setTmpFilter,
                                                                            viewData
}): JSX.Element => {
    const { classes, cx } = useStyles();
    const equipments = viewData?.equipmentList?.equipments;
    const { t } = useTranslation();

    const getEquipmentsForFilter = () => {
        const allEquipments = equipments;

        return allEquipments;
    };

    const equipmentsForFilter = getEquipmentsForFilter();

    const handleCheckboxChange = (event: any) => {
        let tmpFilter = predefinedFilter.slice();
        if (event.target.checked) {
            if (event.target.value === "%") {
                tmpFilter = [];
                tmpFilter.push("%");
                for (const index in equipmentsForFilter) {
                    tmpFilter.push(equipmentsForFilter[index].equipmentId);
                }
            } else {
                if (tmpFilter.indexOf("%") > -1) {
                    tmpFilter = [];
                }
                tmpFilter.push(event.target.value);
            }
            setTmpFilter(tmpFilter);
        } else {
            if (event.target.value === "%") {
                tmpFilter = [];
            } else {
                tmpFilter = tmpFilter.filter(function (
                    value: string,
                    index: number,
                    arr: any,
                ) {
                    return value !== event.target.value;
                });
            }
            setTmpFilter(tmpFilter);
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Tooltip
                    title={t(
                        "disposition.controls.tooltip.selectAllEquipments",
                    )}
                >
                    <Button
                        variant={"outlined"}
                        size={"small"}
                        color={"secondary"}
                        onClick={() => {
                            const tmpFilter = [];

                            const enabledEquipments = equipmentsForFilter;
                            for (const idx in enabledEquipments) {
                                tmpFilter.push(
                                    enabledEquipments[idx].equipmentId,
                                );
                            }
                            setTmpFilter(tmpFilter);
                        }}
                    >
                        {t("disposition.controls.modal.selectAll")}
                    </Button>
                </Tooltip>{" "}
                <Tooltip
                    title={t(
                        "disposition.controls.tooltip.deselectAllEquipments",
                    )}
                >
                    <Button
                        variant={"outlined"}
                        size={"small"}
                        color={"secondary"}
                        onClick={() => {
                            setTmpFilter([]);
                        }}
                    >
                        {t("disposition.controls.modal.deselectAll")}
                    </Button>
                </Tooltip>
            </Grid>
            {equipmentsForFilter?.map((equipment: any) => (
                <Grid item key={equipment.equipmentId} xs={4}>
                    <FormControlLabel
                        control={
                            <>
                                <Checkbox
                                    size={"small"}
                                    name="checkedB"
                                    color="secondary"
                                    value={equipment.equipmentId}
                                    onChange={handleCheckboxChange}
                                    checked={
                                        predefinedFilter.indexOf(
                                            equipment.equipmentId,
                                        ) > -1 &&
                                        predefinedFilter.indexOf("%") <= -1
                                    }
                                />
                                <span
                                    //@ts-ignore
                                    className={cx(
                                        classes.extrasIcon,
                                        "cx9_fzga_ico cx9-" +
                                            equipment.equipmentId,
                                    )}
                                ></span>
                            </>
                        }
                        label={equipment.description}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default EquipmentFilterTab;
